// Thin HTML overlay for menus / settings / IAP screens that don't belong inside Phaser.
// The Phaser canvas runs underneath. Show/hide is toggled via pointer-events + display.

const root = (): HTMLElement => document.getElementById('overlay')!;

/**
 * Mirrored onto <body> so other page-level UI can step aside while a full-screen panel is up.
 *
 * Read by the desktop QR card, which lives outside this element and would otherwise float, at
 * full brightness, over the scrim of every picker, the scoreboard and the privacy policy — the
 * last of which has to stay readable. Everything that opens a panel goes through show()/hide(),
 * so this one pair of lines covers all of them.
 */
const OPEN_CLASS = 'overlay-open';

export function show(html: string): void {
  const el = root();
  el.innerHTML = html;
  el.style.display = 'block';
  el.style.pointerEvents = 'auto';
  document.body.classList.add(OPEN_CLASS);
}

export function hide(): void {
  const el = root();
  el.innerHTML = '';
  el.style.display = 'none';
  el.style.pointerEvents = 'none';
  document.body.classList.remove(OPEN_CLASS);
}
